var _path, _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.445 2.454l1.107 1.7H11a1 1 0 011 1V7.7a.3.3 0 00.3.3h1.4a.3.3 0 00.3-.3V5.154a3 3 0 00-3-3H7.636l-.516-.792A3 3 0 004.607 0H3a3 3 0 00-3 3v9a3 3 0 003 3h4.7a.3.3 0 00.3-.3v-1.4a.3.3 0 00-.3-.3H3a1 1 0 01-1-1V3a1 1 0 011-1h1.607a1 1 0 01.838.454z",
    fill: "#2C2D2E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 2,
    height: 6,
    rx: 0.4,
    fill: "#2C2D2E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 2,
    height: 6,
    rx: 0.4,
    transform: "rotate(-90 10 14)",
    fill: "#2C2D2E"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik01LjQ0NDg0IDIuNDU0MDVMNi41NTI0NyA0LjE1Mzg1SDExQzExLjU1MjMgNC4xNTM4NSAxMiA0LjYwMTU2IDEyIDUuMTUzODVWNy43QzEyIDcuODY1NjkgMTIuMTM0MyA4IDEyLjMgOEgxMy43QzEzLjg2NTcgOCAxNCA3Ljg2NTY5IDE0IDcuN1Y1LjE1Mzg1QzE0IDMuNDk2OTkgMTIuNjU2OSAyLjE1Mzg1IDExIDIuMTUzODVINy42MzYzNkw3LjEyMDQ4IDEuMzYyMTZDNi41NjY3NyAwLjUxMjQzMyA1LjYyMTIzIDAgNC42MDcwMiAwSDNDMS4zNDMxNSAwIDAgMS4zNDMxNSAwIDNWMTJDMCAxMy42NTY5IDEuMzQzMTUgMTUgMyAxNUg3LjdDNy44NjU2OCAxNSA4IDE0Ljg2NTcgOCAxNC43VjEzLjNDOCAxMy4xMzQzIDcuODY1NjggMTMgNy43IDEzSDNDMi40NDc3MiAxMyAyIDEyLjU1MjMgMiAxMlYzQzIgMi40NDc3MiAyLjQ0NzcyIDIgMyAySDQuNjA3MDJDNC45NDUwOSAyIDUuMjYwMjcgMi4xNzA4MSA1LjQ0NDg0IDIuNDU0MDVaIiBmaWxsPSIjMkMyRDJFIi8+CiAgICA8cmVjdCB4PSIxMiIgeT0iMTAiIHdpZHRoPSIyIiBoZWlnaHQ9IjYiIHJ4PSIwLjQiIGZpbGw9IiMyQzJEMkUiLz4KICAgIDxyZWN0IHg9IjEwIiB5PSIxNCIgd2lkdGg9IjIiIGhlaWdodD0iNiIgcng9IjAuNCIgdHJhbnNmb3JtPSJyb3RhdGUoLTkwIDEwIDE0KSIgZmlsbD0iIzJDMkQyRSIvPgo8L3N2Zz4K";
export { SvgAddFolder as ReactComponent };